import { Navigate, Outlet } from "react-router-dom";
import { getUserInfo } from "../api/authToken";

/**
 * Route guard: blocks the authenticated area of the app when there is no
 * active session, redirecting to the login page instead of rendering pages
 * (which previously loaded regardless of auth state).
 */
const ProtectedRoute = () => {
  const info = getUserInfo();
  if (!info?.access) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
